import { render, staticRenderFns } from "./DateLocalePicker.vue?vue&type=template&id=b771747a&scoped=true"
import script from "./DateLocalePicker.vue?vue&type=script&lang=js"
export * from "./DateLocalePicker.vue?vue&type=script&lang=js"
import style0 from "./DateLocalePicker.vue?vue&type=style&index=0&id=b771747a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b771747a",
  null
  
)

export default component.exports